// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSearch_container__1zHqP","searchContainer":"ProductSearch_searchContainer__VJRBH"};